// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import AddressFormController from "./address_form_controller"
import BrowserTimezoneController from "./browser_timezone_controller"
import ClipboardController from "./clipboard_controller"
import MobileNavController from "./mobile_nav_controller"
import MobilePrefixController from "./mobile_prefix_controller"
import PlayerInvitesController from "./player_invites_controller"
import SignupEmailController from "./signup_email_controller"
import TenantVenueCalendarController from "./tenant_venue_calendar_controller"
import TeamJoinFormController from "./team_join_form_controller"
import TogglePanelController from "./toggle_panel_controller"
import TimezoneSelectController from "./timezone_select_controller"
import TournamentGenderController from "./tournament_gender_controller"
import VoteFormController from "./vote_form_controller"
application.register("address-form", AddressFormController)
application.register("browser-timezone", BrowserTimezoneController)
application.register("clipboard", ClipboardController)
application.register("hello", HelloController)
application.register("mobile-nav", MobileNavController)
application.register("mobile-prefix", MobilePrefixController)
application.register("player-invites", PlayerInvitesController)
application.register("signup-email", SignupEmailController)
application.register("tenant-venue-calendar", TenantVenueCalendarController)
application.register("team-join-form", TeamJoinFormController)
application.register("toggle-panel", TogglePanelController)
application.register("timezone-select", TimezoneSelectController)
application.register("tournament-gender", TournamentGenderController)
application.register("vote-form", VoteFormController)
